export default "__VITE_ASSET__Zo$$zu8a__"